import { axiosGet } from "./api";

export const fetchPageData = async (pageName) => {
  try {
    const response = await axiosGet(
      `api/method/alltimes.alltimes_travel.doctype.pages.pages.page`,
      { name: pageName }
    );
    return { data: response.result, error: null };
  } catch (error) {
    const serverMessage = (() => {
      try {
        const messages = JSON.parse(error.response?.data?._server_messages || '[]');
        return messages[0]?.message || 'Something went wrong';
      } catch {
        return 'Something went wrong';
      }
    })();

    return {
      data: null,
      error: {
        code: error.response?.status?.toString() || "500",
        message: error.response?.statusText || error.message || "Unknown Error",
        description: serverMessage,
      },
    };
  }
};